import {HttpParams,  HttpClient,   HttpRequest} from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/Rx';

import { APP_CONFIG } from '../app.config';
import { AuthService } from './auth.service';

@Injectable()
export class DomainService {
    domainLogin = new Subject<any>();

    onGetDomainListings = new Subject();
    onGetDomainListing = new Subject();

    constructor(
        @Inject(APP_CONFIG) private appConfig,
        private httpClient: HttpClient,
        private authService: AuthService
    ) {}

    httpLogin(data: any) {
        const req = new HttpRequest(
            'POST',
            this.appConfig.API_ENDPOINT + '/domain/login',
            data
        );

        return this.httpClient.request<any>(req)
        .map(
            (response: any) => {
            if (response.body) {
                if ( typeof response.body.status !== 'undefined') {
                    return response.body;
                }
            }

            return [];
            }
        )
        .subscribe(
            (response: any) => {
                this.domainLogin.next(response);
            },
            (response: any) => {
                this.domainLogin.next(response.error);
            }
        );
    }

    httpGetListings(params: any = []) {
        let httpParams = new HttpParams();

        for (const p of Object.keys(params)) {
          httpParams = httpParams.append(p, params[p]);
        }

        const req = new HttpRequest(
          'GET',
          this.appConfig.API_ENDPOINT + '/domain/listings',
          {
            params: httpParams
          }
        );

        return this.httpClient.request(
          req
        )
        .map(
            (response: any) => {
              if (typeof response.body !== 'undefined' && response.body != null) {
                  return response.body;
              }

              return [];
            }
        )
        .subscribe(
          (response: any) => {
            this.onGetDomainListings.next(response);
          },
          (response: any) => {
            this.onGetDomainListings.next(response.error);
          }
        );
    }

    httpGetListing(id: number, params: any = []) {
      let httpParams = new HttpParams();

      for (const p of Object.keys(params)) {
        httpParams = httpParams.append(p, params[p]);
      }

      const req = new HttpRequest(
        'GET',
        this.appConfig.API_ENDPOINT + '/domain/listing/' + id,
        {
          params: httpParams
        }
      );

      return this.httpClient.request(
        req
      )
      .map(
          (response: any) => {
            if (typeof response.body !== 'undefined' && response.body != null) {
                return response.body;
            }

            return [];
          }
      )
      .subscribe(
        (response: any) => {
          this.onGetDomainListing.next(response);
        },
        (response: any) => {
          this.onGetDomainListing.next(response.error);
        }
      );
    }
}



// WEBPACK FOOTER //
// ./src/app/services/domain.service.ts